




































import i18n from "@/i18n";
import moment from "moment";
import { getPlayer } from "@/services/players/playerService";
import { Player } from "@/services/players/types";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class PlayerInfoModal extends Vue {
    config = {} as any;
    playerInfo = {} as Player;

    open(playerId: string) {
        getPlayer(playerId).then(response => {
            this.playerInfo = response;
            this.$bvModal.show("modal-playerInfo");
        });
    }

    hide() {
        this.$bvModal.hide("modal-playerInfo");
    }

    formatDate(date: Date) {
        return moment.utc(date).local().format("LLL");
    }

    localizeName(name: string) {
        switch (name.toLowerCase()) {
        case "last active":
            return i18n.t("posts.status");
        case "name":
        case "pcnavn":
            return i18n.t("player.playerPcName");
        default:
            return name;
        }
    }
}
